export const actionTypes = {
  REMOVE_TOAST: "REMOVE_TOAST",

  GET_USERS: "GET_USERS",
  GET_USERS_SUCCESS: "GET_USERS_SUCCESS",
  GET_USERS_FAILED: "GET_USERS_FAILED",

  GET_SINGLE_USER: "GET_SINGLE_USER",
  GET_SINGLE_USER_SUCCESS: "GET_SINGLE_USER_SUCCESS",
  GET_SINGLE_USER_FAILED: "GET_SINGLE_USER_FAILED",

  GET_CLIENTS: "GET_CLIENTS",
  GET_CLIENTS_SUCCESS: "GET_CLIENTS_SUCCESS",
  GET_CLIENTS_FAILED: "GET_CLIENTS_FAILED",

  REGISTER_USER: "REGISTER_USER",
  REGISTER_USER_SUCCESS: "REGISTER_USER_SUCCESS",
  REGISTER_USER_FAILED: "REGISTER_USER_FAILED",

  INVITE_USER: "INVITE_USER",
  INVITE_USER_SUCCESS: "INVITE_USER_SUCCESS",
  INVITE_USER_FAILED: "INVITE_USER_FAILED",

  REINVITE_USER: "REINVITE_USER",
  REINVITE_USER_SUCCESS: "REINVITE_USER_SUCCESS",
  REINVITE_USER_FAILED: "REINVITE_USER_FAILED",

  UPDATE_USER: "UPDATE_USER",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  UPDATE_USER_FAILED: "UPDATE_USER_FAILED",

  DELETE_USER: "DELETE_USER",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  DELETE_USER_FAILED: "DELETE_USER_FAILED",

  DELETE_PROFILE: "DELETE_PROFILE",
  DELETE_PROFILE_SUCCESS: "DELETE_PROFILE_SUCCESS",
  DELETE_PROFILE_FAILED: "DELETE_PROFILE_FAILED",

  UPDATE_USER_STATUS: "UPDATE_USER_STATUS",
  UPDATE_USER_STATUS_SUCCESS: "UPDATE_USER_STATUS_SUCCESS",
  UPDATE_USER_STATUS_FAILED: "UPDATE_USER_STATUS_FAILED",
}

export const actionCreators = {
  removeToast: () => ({ type: actionTypes.REMOVE_TOAST }),
  getUser: params => ({ type: actionTypes.GET_USERS, params }),
  getSingleUser: params => ({ type: actionTypes.GET_SINGLE_USER, params }),
  getClient: params => ({ type: actionTypes.GET_CLIENTS, params }),
  registerUser: body => ({ type: actionTypes.REGISTER_USER, body }),
  inviteUser: body => ({ type: actionTypes.INVITE_USER, body }),
  reinviteUser: body => ({ type: actionTypes.REINVITE_USER, body }),
  deleteUser: id => ({ type: actionTypes.DELETE_USER, id }),
  deleteProfile: (body, id) => ({ type: actionTypes.DELETE_PROFILE, body, id }),
  updateUser: (id, body) => ({ type: actionTypes.UPDATE_USER, id, body }),
  updateUserStatus: (id, body) => ({ type: actionTypes.UPDATE_USER_STATUS, id, body })
}

const initialState = {
  data: null,
  data_single: null,
  client: {
    data: null,
    meta: null
  },
  meta: null,
  isLoading: false,
  toast: null,
  errors: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REMOVE_TOAST:
      return Object.assign({}, state, { toast: null });

    case actionTypes.GET_USERS:
    case actionTypes.GET_SINGLE_USER:
    case actionTypes.GET_CLIENTS:
    case actionTypes.INVITE_USER:
    case actionTypes.REINVITE_USER:
    case actionTypes.UPDATE_USER:
    case actionTypes.UPDATE_USER_STATUS:
    case actionTypes.DELETE_USER:
    case actionTypes.DELETE_PROFILE:
      return Object.assign({}, state, { isLoading: true, errors: null });

    case actionTypes.GET_USERS_SUCCESS:
      return Object.assign({}, state, {
        data: action.payload.data,
        meta: action.payload.meta,
        isLoading: false,
        errors: null,
      });

    case actionTypes.GET_SINGLE_USER_SUCCESS:
      return Object.assign({}, state, {
        data_single: action.payload.data,
        isLoading: false,
        errors: null,
      });

    case actionTypes.GET_CLIENTS_SUCCESS:
      return Object.assign({}, state, {
        client: action.payload,
        isLoading: false,
        errors: null,
      });

    case actionTypes.INVITE_USER_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: {
          type: "success",
          message: "Invite successful",
          request: "add"
        }
      });

    case actionTypes.REINVITE_USER_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: {
          type: "success",
          message: "Re-Invite successful",
          request: "add-repeat"
        }
      });

    case actionTypes.UPDATE_USER_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: {
          type: "success",
          message: "Update successful"
        }
      });

    case actionTypes.DELETE_USER_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: {
          type: "success",
          message: "Delete successful",
          request: 'delete'
        }
      });

    case actionTypes.DELETE_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: {
          type: "success",
          message: "Your account has been deleted, Logging you out",
          request: "delete-profile"
        }
      });

    case actionTypes.UPDATE_USER_STATUS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        toast: {
          type: "success",
          message: "Update Status Success"
        }
      });

    case actionTypes.GET_USERS_FAILED:
    case actionTypes.GET_SINGLE_USER_FAILED:
    case actionTypes.GET_CLIENTS_FAILED:
    case actionTypes.INVITE_USER_FAILED:
    case actionTypes.REINVITE_USER_FAILED:
    case actionTypes.UPDATE_USER_FAILED:
    case actionTypes.UPDATE_USER_STATUS_FAILED:
    case actionTypes.DELETE_USER_FAILED:
    case actionTypes.DELETE_PROFILE_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        toast: {
          type: "failed",
          message: action.payload.error
        }
      });

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/user/reducer.js